import React from "react";
import { useTranslation } from "react-i18next";
const WhoisAdapterSummary = ({ dataAdapter }) => {
  const { t } = useTranslation("integrations");
  const { config } = dataAdapter;
  return /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("dt", null, t("whois_adapter_field_set.connect_timeout_label")), /* @__PURE__ */ React.createElement("dd", null, config.connect_timeout, " ", t("whois_adapter_summary.unit_ms")), /* @__PURE__ */ React.createElement("dt", null, t("whois_adapter_field_set.read_timeout_label")), /* @__PURE__ */ React.createElement("dd", null, config.read_timeout, " ", t("whois_adapter_summary.unit_ms")));
};
export default WhoisAdapterSummary;
